import { createContext } from 'react';

const BannerContext = createContext(undefined);

export { BannerContext };
//# sourceMappingURL=banner-context.js.map
